// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8a076426","684":"d8d975f8","921":"cbfb39a4"}[chunkId] + ".chunk.js";
};